


































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  RimRepairLayoutComponent,
  RimRepairAutocompleteComponent,
  RimRepairModalComponent,
} from "@/components/common";
import {
  ICustomer,
  IWorkOrder,
  ILineItem,
  IInvoiceSaveDraftRequest,
  IPaymentData,
  IWorkOrderCard,
  IWhoAmI,
  IStaff,
  ICarJob, ICustTypeDto, INotifyInvoiceRequest
} from "@/interfaces";
import {
  SearchCustomers,
  GetCustomer,
  GetWorOrder,
  SubmitInvoice,
  // InvoiceBegin,
  InvoiceSaveDraft,
  GetInvoice,
  GetWorkOrders,
  InsertCustomer,
  NotifyInvoice,
} from "@/api";
import { makeInvoice, formatDate, makeCustomer } from "@/utils";
import PaymentMethodsComponent from "./payment-methods.vue";
// import CustomerDataComponent from "./customer.vue";
import SuperCustomerEditor from "./super-customer-editor.vue";
import SubmitInvoiceComponent from "./submit-invoice.vue";
import VehicleFormComponent from "./vehicles-form.vue";
import VehiclesTableComponent from "./vehicles-table.vue";
import { Getter } from "vuex-class";
import { HELPER } from "../../../utils/Helper";
import { UserInterface } from "@/utils/UserInterface";
import CustomerTabs from "../office/customer-tabs.vue";
import NonZeroInput from '../../common/non-zero-input.vue'

@Component({
	beforeRouteLeave: function(from, to, next){
		 (this as any).SaveOnLeaving(from, to, next)
		 .then(()=>{
			//  console.log('draft saved before leaving route...');
			 next();
		 })
	},
  components: {
    RimRepairLayoutComponent,
    RimRepairAutocompleteComponent,
    PaymentMethodsComponent,
    // CustomerDataComponent,
    SuperCustomerEditor,
    SubmitInvoiceComponent,
    RimRepairModalComponent,
    VehicleFormComponent,
    VehiclesTableComponent,
    CustomerTabs, NonZeroInput
  },
})
export default class InvoiceFormComponent extends Vue {
  public selectedStep = 1;
  public defaultCustomer = 0;
  public selectedCustomer: ICustomer | null = null;
  public selectedWorkOrder: IWorkOrder | IWorkOrderCard | null = null;
  public searchWorkOrder = 0;
  public invoice = makeInvoice({});
  public loading = false;
  public dialog = false;
	public dialogDraft = false;
  public date: string = formatDate(new Date().toDateString(), "MM/dd/yyyy");
  @Getter("staffWithMe", { namespace: "AppModule" })
  public staff!: IStaff[];
  @Getter("user", { namespace: "AppModule" })
  public user!: IWhoAmI | null;

  public ShowNewCustomerDialog: boolean = false;
  public InsertingCustomer: ICustomer = makeCustomer({});

  public H: HELPER = HELPER;

	private UI__: UserInterface;

	/*
	SET TO TRUE WHEN IT'S DESIREABLE
	*/
	public showAllSteps:boolean = false;


  mounted() {
    this.UI__ = new UserInterface(this);

    if (this.$route.params.id) {
      this.getData();
    } else {
      // this.invoiceBegin();
		}
  }


	private ctnam: string = null;

	@Watch('selectedCustomer', {deep:true})
	onCustChanged(newVal: ICustomer, oldVal:ICustomer){
		/* 
		IF oldVal == null IT MEANS THE COMPONENT IS JUST BEING 
		ASSEMBLED, IN THIS CASE (ON PAGE LOAD) WE DON'T WANT TO 
		CHANGE AN EXISTING TAX STATUS ! 
		*/
		var nuval = JSON.stringify(newVal.CustType.CustTypeFlags);

		if (oldVal==null){
			this.ctnam = nuval;
			return;
		}


		/* 
		RESET PAYMENT INFORMATION WHEN THE CUSTOMER CHANGES,
		THIS IS TO AVOID ISSUES SUCH AS HIDING A PAYMENT METHOD
		BUT THIS METHOD STILL HAS A VALUE STORED, HAVING A PREVIOUS 
		PAYMENT METHOD SELECTED, BUT THEN IT GOT HIDDEN BUT IT'S STILL SELECTED,
		ETC.
		*/
		var changed = this.ctnam != nuval;

		this.ctnam = nuval;



		/* RESET NOT NEEDED IF THERE ISN'T A CUST-TYPE CHANGE.
		*/
		if (!changed)
			return;



		var isTaxable = this.HasFlag(60);

		this.invoice.Invoice.PaymentData.Tax = isTaxable;


		this.invoice.Invoice.PaymentData.PayByCheck = false;
		this.invoice.Invoice.PaymentData.PayByCreditCard = false;
		this.invoice.Invoice.PaymentData.PayByCash = false;
		this.invoice.Invoice.PaymentData.PayByPurchaseOrder = false;
		this.invoice.Invoice.PaymentData.PayByAuth = false;

		this.invoice.Invoice.PaymentData.PayByCheckAmount = 0;
		this.invoice.Invoice.PaymentData.PayByCreditCardAmount = 0;
		this.invoice.Invoice.PaymentData.PayByCashAmount = 0;
		this.invoice.Invoice.PaymentData.PayByAuthAmount = 0;

		// this.invoice.Invoice.InvoiceSubTotal = 0;
		this.invoice.Invoice.PaymentData.InvoicePayments = 0;
		this.invoice.Invoice.PaymentData.InvoiceTax = 0;
		this.invoice.Invoice.PaymentData.InvoiceTotal = 0;
		
	}


  get getName() {
    let name = "";
    if (this.$route.params.id) {
      if (this.invoice.Invoice.TechID) {
        const user = this.staff.find(
          (s) => s.RecordID === this.invoice.Invoice.TechID
        );

				if (user!=null){
	        name = user!.FName + " " + user!.LName;
				}else{
					name = 'Staff #'+this.invoice.Invoice.TechID+' not found';
				}
			}
    } else {
      if (this.user) {
        name = this.user!.FName + " " + this.user.LName;
      }
    }
    return name;
  }

  async getData() {
		let selectedStep = 1;
    try {
      this.loading = true;
      const resp = await GetInvoice(this.$route.params.id);
			
			/* 
				 SET A TAX-VALUE IN THE OBJECT, OTHERWISE
				 IT WILL NOT BE REACTIVE. 
			*/
			if (resp.Invoice.PaymentData.Tax == null){
				resp.Invoice.PaymentData.Tax= null;
			}

			this.invoice = makeInvoice({
        Invoice: resp.Invoice,
      });

      this.date = formatDate(this.invoice.Invoice.CreatedOn!, "MM/dd/yyyy");
      if (this.invoice.Invoice.CustomerID) {
        this.defaultCustomer = +this.invoice.Invoice.CustomerID!;
        const customerResp = await this.searchCustomerFn(this.defaultCustomer);
        this.selectedCustomer = customerResp[0];
        selectedStep = 2;
      }
      if (this.invoice.Invoice.CarJobs!.length) {
        selectedStep = 3;
      }
      this.selectedStep = selectedStep;
      this.loading = false;
      this.updateSubTotal();
    } catch (err) {
      //
    }
  }

  async searchCustomerFn(value: string | number): Promise<ICustomer[]> {
    if (typeof value === "number") {
      const resp = await GetCustomer(value);
      return resp.Ok ? [resp.Customer] : [];
    } else {
      const resp = await SearchCustomers(value, 0, 5);
      return resp.Ok ? resp.Results.Customers : [];
    }
  }


  async invoiceSaveDraft(withCustomer: boolean = false) {
    var cust: any = null;
    if (withCustomer) cust = this.selectedCustomer;

	this.invoice.Invoice.CustomerID
    try {
      const resp = await InvoiceSaveDraft({
        Invoice: this.invoice.Invoice,
        Customer: cust,
      });

    } catch (err) {
    }

  }

  goToStepTwo(): void {
    var el = this.$refs.frmCustomerEdit as HTMLFormElement;
    if (!el.validate()) return;


    this.selectedStep = 2;
    this.invoiceSaveDraft(true);
  }


	updatemention(paymentMethods: IPaymentData)
	{
    this.invoice.Invoice.PaymentData = paymentMethods;
	}

	

  updateCarJobs(data: ICarJob[]) {
    this.invoice.Invoice.CarJobs = data;
    this.updateSubTotal();
  }

  updateSubTotal() {
    let total = 0;
    this.invoice.Invoice.CarJobs!.forEach((item) => {
      item.JobDetails.forEach((detail) => {
        if (detail.JobPrice) total = total + +detail.JobPrice;
      });
    });
    this.invoice.Invoice.PaymentData.InvoiceSubTotal = total;
  }

  updateCustomer(customer: ICustomer) {
    this.selectedCustomer = customer;
		this.invoice.Invoice.CustomerID = this.selectedCustomer.RecordID;
		this.invoice.Invoice.CustomerName = HELPER.GetCustomerName(this.selectedCustomer);
  }

  async saveItems() {
    if ((this.$refs.vehiclesForm as VehicleFormComponent).validate()) {
      this.selectedStep = 3;
      this.invoiceSaveDraft();
    }
  }

  async submit() {
    var isValid = (this.$refs.frmMethods as HTMLFormElement).validate();
    if (!isValid) {
      this.$store.dispatch("AppModule/setSnackbar", {
        status: "error",
        message: "Review the Form for completeness before Submitting",
      });

      return;
    }

    if (
      this.invoice.Invoice.PaymentData.PayByPurchaseOrder &&
      (this.invoice.Invoice.PaymentData.PayByCash ||
        this.invoice.Invoice.PaymentData.PayByCheck ||
				this.invoice.Invoice.PaymentData.PayByCreditCard ||
				this.invoice.Invoice.PaymentData.PayByAuth
				)
    ) {
      this.$store.dispatch("AppModule/setSnackbar", {
        status: "error",
        message:
          "If you select Purchase Order, it must be the only payment method",
      });

      return;
    }

    if (
      this.invoice.Invoice.PaymentData.PayByCash ||
      this.invoice.Invoice.PaymentData.PayByCheck ||
      this.invoice.Invoice.PaymentData.PayByPurchaseOrder ||
      this.invoice.Invoice.PaymentData.PayByCreditCard ||
      this.invoice.Invoice.PaymentData.PayByAuth 
    ) {
      if (!this.invoice.Invoice.PaymentData.CustomerSignature) {
        this.$store.dispatch("AppModule/setSnackbar", {
          status: "error",
          message: "Please Sign the Invoice",
        });
        return;
      }
      this.invoiceSaveDraft();
      this.dialog = true;
    } else {
      this.$store.dispatch("AppModule/setSnackbar", {
        status: "error",
        message: "Select A Payment Method",
      });
    }
  }

  public HasFlag(id: number): boolean {
    if (!this.selectedCustomer) return false;
    var iof = (this
      .selectedCustomer as ICustomer).CustType.CustTypeFlags.indexOf(id);
    var hasIt: boolean = iof > -1;
    return hasIt;
  }

  public GetReturnPath(): string {
    /*
		THE RETURN PATH (THE BACK BUTTON) 
		IS SLIGHTLY DIFFERENT DEPENDING IF IT'S
		THE "CONTROLLER" EDITING AN INVOICE, OR A "TECHNICIAN" EDITING IT. 
		*/
    var rval: string = "/invoices";

    if (this.$route.name == "invoices-controller-edit")
      rval = "/invoices-controller";

    return rval;
  }

  public async CompleteInvoice(recipients: string[], message: string) {
    if (!recipients || recipients.length == 0) {
      this.UI__.SnacError("Add at least one Email Recipient");
      return;
    }

    this.invoice.EmailRecipients = recipients;
		this.invoice.MessageForCustomer = message;

    this.UI__.TurnBlockerOn();
    let resp = await SubmitInvoice(this.invoice);
    this.UI__.TurnBlockerOff();

    if (resp.Ok) {
      this.dialog = false;

      this.UI__.SnacSuccess(
        `Invoice ${this.invoice.Invoice.InvoiceNumber} successfully generated`
      );

      this.$router.push(this.GetReturnPath());
    } else {
      this.UI__.SnacError(resp.Msg);
    }
  }

  public CreateNewCustomer(): void {
    this.ShowNewCustomerDialog = true;
  }

  public CancelCreating(): void {
    this.ShowNewCustomerDialog = false;
  }

  public async CreateCustomerBegin() {
    var isValid: boolean = (this.$refs
      .frmNewcust as HTMLFormElement).validate();

    if (isValid) {
      // this.buttonLoading = true;

      this.UI__.TurnBlockerOn();
      let resp = await InsertCustomer(this.InsertingCustomer);

      // this.buttonLoading = false;
      if (resp.Ok) {
        let cust = await GetCustomer(resp.CustomerID);

        if (!cust.Ok) {
          /*
					ERROR WHILE RETRIEVING THE RECENTLY CREATED CUSTOMER
					*/
          this.UI__.SnacError(
            "Error retrieving the recently created customer: " + cust.Msg
          );

          /*
				CLOSE AND RESET THE INSERT DIALOG, SINCE THE CUSTOMER WAS INSERTED
				ANYWAY.
				*/
        } else {
					this.updateCustomer(cust.Customer);
          this.UI__.SnacSuccess(`Customer Created Successfully !`);
        }

        this.InsertingCustomer = makeCustomer({});

        this.ShowNewCustomerDialog = false;
      } else {
        this.UI__.SnacError(resp.Msg);
      }

      this.UI__.TurnBlockerOff();
    } else {
      this.UI__.SnacError(
        `Fix Validation Errors`
      );
    }
  }



	public async SubmitInvoiceLater_WithSend(recipients: string[], message:string){
		/*
		WE DON'T SAVE HERE, WE CHANGE THE ROUTE AS IF THE "BACK" 
		BUTTON WAS PRESSED, CHANGING THE ROUTE AUTOMATICALLY 
		TRIGGERS THE SAVE EVENT.
		*/
		// await this.SaveOnLeaving();

		if (!recipients || recipients.length == 0) {
      this.UI__.SnacError("Add at least one Email Recipient");
      return;
    }

		this.UI__.TurnBlockerOn();

    var req: INotifyInvoiceRequest = {
      InvoiceNumber: this.invoice.Invoice.InvoiceNumber,
			Recipients: recipients,
			MessageForCustomer: message,
			IsSubmittingLater: true,
    };
		let resp =await  NotifyInvoice(req);
    this.UI__.TurnBlockerOff();

    if (resp.Ok) {
      this.dialogDraft = false;

      this.UI__.SnacSuccess(
        `Invoice ${this.invoice.Invoice.InvoiceNumber} Sent to Customer and Saved Draft`
      );
      this.$router.push(this.GetReturnPath());
    } else {
      this.UI__.SnacError(resp.Msg);
    }
	}



	public async SubmitInvoiceLater_WithoutSend()
	{
	/*
		WE DON'T SAVE HERE, WE CHANGE THE ROUTE AS IF THE "BACK" 
		BUTTON WAS PRESSED, CHANGING THE ROUTE AUTOMATICALLY 
		TRIGGERS THE SAVE EVENT.
		*/
		this.$router.push(this.GetReturnPath());
	}


	public async SaveOnLeaving(){
		this.UI__.TurnBlockerOn();
		await this.invoiceSaveDraft();
		this.UI__.TurnBlockerOff();
		this.UI__.SnacSuccess("Draft Saved !");

		this.RefreshInvoices();
	}


	private RefreshInvoices(){
		/// WILL DISPATCH A NOTIFICATION,
		/// SO COMPONENTS SHOWING INVOICES WILL REFRESH
		/// TO SHOW UPDATED DATA.
		this.UI__.RefreshTimestampInvoices();	
	}





}
